export const compatibleDevices: string[] = ['W482CAD', 'W452AD', 'W881AA', 'F861AS', 'W463AQ', 'SL300', 'B862AJ', 'B451AJ', 'B451AJU', 'W891UA', 'B463AJ'];